import React          from 'react'
import { Collapse }   from 'react-bootstrap'
import classnames     from 'classnames'
import ImageCaretDown from 'images/products/caret-down.svg'
import ImageCaretUp   from 'images/products/caret-up.svg'

class OffshoreWrapper extends React.Component {
  constructor(props) {
    super(props)
    this.onSwitchCollapse = this.onSwitchCollapse.bind(this)

    this.state = {
      show: true,
    }
  }

  onSwitchCollapse() {
    this.setState({ show: !this.state.show })
  }

  render() {
    const btnKlass = classnames('btn btn-primary btn-toggle-offshore-pcb', {
      'panel-collapse-hide': this.state.show,
      'd-none'             : true,
    });

    const caretImage = this.state.show ? ImageCaretUp : ImageCaretDown;

    return (
      <div>
        <button
          type="button"
          className={btnKlass}
          onClick={this.onSwitchCollapse}>
          {`${this.state.show ? 'hide' : 'show'} offshore pcb prices`}
          <img src={caretImage} />
        </button>
        <Collapse in={this.state.show}>
          {this.props.children}
        </Collapse>
      </div>
    )
  }
}

export default OffshoreWrapper
